<script setup>
import ConfirmDialog from 'primevue/confirmdialog'
import Toast from 'primevue/toast'
import { onMounted } from 'vue'

import { useTheme } from '@/stores/theme'

const theme = useTheme()
onMounted(() => { theme.apply(); theme.watchSystem() })
</script>

<template>
  <RouterView />
  <Toast position="bottom-right" />
  <ConfirmDialog />
</template>
